<template>
  <div>
    <div @click="updateCheck()" class="checkbox">
      <img v-if="checkValue" height="15" width="15" src="../assets/images/blue-checkbox.png" />
      <img v-if="!checkValue" height="15" width="15" src="../assets/images/blue-uncheckedbox.png" />
      <span>
        {{labelValue}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabeledCheckbox',
  props: { // props passed into component
    labelValue: String,
    checkValue: Boolean
  },
  methods: {
    updateCheck() {
      this.$emit('update');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  span {
    margin-left: 8px;
  }
  .checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px 0px;
  }
</style>